export var SortOrder;
(function (SortOrder) {
    SortOrder["TitleAZ"] = "title_asc";
    SortOrder["TitleZA"] = "title_desc";
    SortOrder["Newest"] = "newest";
    SortOrder["Oldest"] = "oldest";
})(SortOrder || (SortOrder = {}));
export var ResourceType;
(function (ResourceType) {
    ResourceType["VectorLayer"] = "VectorLayer";
    ResourceType["RasterLayer"] = "RasterLayer";
    ResourceType["Table"] = "Table";
    ResourceType["PythonNotebook"] = "PythonNotebook";
    ResourceType["ExternalApplication"] = "ExternalApplication";
    ResourceType["Scenario"] = "Scenario";
})(ResourceType || (ResourceType = {}));
export var LayerType;
(function (LayerType) {
    LayerType["Vector"] = "Vector";
    LayerType["Raster"] = "Raster";
    LayerType["All"] = "All";
})(LayerType || (LayerType = {}));
export var InternalDistributionFormat;
(function (InternalDistributionFormat) {
    InternalDistributionFormat["WMS"] = "WMS";
    InternalDistributionFormat["WFS"] = "WFS";
    InternalDistributionFormat["Feature"] = "Feature";
    InternalDistributionFormat["MVT"] = "MVT";
    InternalDistributionFormat["XyzTile"] = "XyzTile";
})(InternalDistributionFormat || (InternalDistributionFormat = {}));
export var InternalDistributionType;
(function (InternalDistributionType) {
    InternalDistributionType["Esri"] = "Esri";
    InternalDistributionType["Geoserver"] = "Geoserver";
    InternalDistributionType["PostGISTileServer"] = "PostGISTileServer";
})(InternalDistributionType || (InternalDistributionType = {}));
